import React from "react";
import PublicLegalPage from "./PublicLegalPage";

export default function PublicAGB() {
  return (
    <PublicLegalPage
      title="Allgemeine Geschäftsbedingungen (AGB) der EasyGutachter Software GmbH"
      subtitle="Für die Nutzung der EasyGutachter Software durch Unternehmer, Kfz-Sachverständige, Gutachterbüros, Franchise- und Lizenzpartner"
      lastUpdated="13. Juni 2026"
      testid="page-public-agb"
    >
      <h2>§ 1 Geltungsbereich</h2>
      <p>
        Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für sämtliche Verträge zwischen der{" "}
        <strong>EasyGutachter Software GmbH</strong>, nachfolgend &bdquo;EasyGutachter&ldquo; genannt,
        und ihren Kunden, nachfolgend &bdquo;Nutzer&ldquo; genannt.
      </p>
      <p>
        Die Leistungen von EasyGutachter richten sich ausschließlich an Unternehmer im Sinne des{" "}
        § 14 BGB, juristische Personen des öffentlichen Rechts sowie öffentlich-rechtliche
        Sondervermögen.
      </p>
      <p>Verbraucher im Sinne des § 13 BGB sind von der Nutzung ausgeschlossen.</p>
      <p>
        Entgegenstehende oder abweichende Geschäftsbedingungen des Nutzers finden keine Anwendung,
        sofern EasyGutachter deren Geltung nicht ausdrücklich schriftlich zugestimmt hat.
      </p>

      <h2>§ 2 Vertragsgegenstand</h2>
      <p>EasyGutachter stellt dem Nutzer eine cloudbasierte Softwarelösung zur Verfügung.</p>
      <p>Die Software dient insbesondere:</p>
      <ul>
        <li>der Auftragserfassung,</li>
        <li>der Erstellung von Kfz-Gutachten,</li>
        <li>der Verwaltung von Fahrzeugdaten,</li>
        <li>der Schadenskalkulation,</li>
        <li>der Dokumentenverwaltung,</li>
        <li>der Speicherung von Lichtbildern,</li>
        <li>der Kommunikation mit Versicherungen,</li>
        <li>der Verwaltung von Kundendaten,</li>
        <li>der digitalen Aktenführung,</li>
        <li>der Rechnungsstellung,</li>
        <li>der KI-gestützten Unterstützung bei Gutachtenerstellungen.</li>
      </ul>
      <p>
        EasyGutachter ist berechtigt, Funktionen zu erweitern, anzupassen oder technisch
        weiterzuentwickeln. Ein Anspruch auf bestimmte zukünftige Funktionen besteht nicht.
      </p>

      <h2>§ 3 Registrierung und Benutzerkonto</h2>
      <p>Die Nutzung der Software setzt eine erfolgreiche Registrierung voraus.</p>
      <p>Sämtliche Angaben des Nutzers müssen vollständig und wahrheitsgemäß erfolgen.</p>
      <p>Zugangsdaten sind geheim zu halten.</p>
      <p>Der Nutzer haftet für sämtliche Handlungen, die unter seinem Benutzerkonto vorgenommen werden.</p>
      <p>Die Weitergabe von Zugangsdaten an Dritte ist untersagt.</p>
      <p>
        Der Nutzer verpflichtet sich, EasyGutachter unverzüglich über einen Missbrauch seines Accounts
        zu informieren.
      </p>

      <h2>§ 4 Nutzungsrechte</h2>
      <p>
        EasyGutachter gewährt dem Nutzer ein einfaches, nicht ausschließliches und nicht übertragbares
        Nutzungsrecht.
      </p>
      <p>Das Nutzungsrecht besteht ausschließlich während der Vertragslaufzeit.</p>
      <p>Es ist insbesondere untersagt:</p>
      <ul>
        <li>die Software zu kopieren,</li>
        <li>die Software zu vervielfältigen,</li>
        <li>Quellcode auszulesen,</li>
        <li>Reverse Engineering durchzuführen,</li>
        <li>Sicherheitsmechanismen zu umgehen,</li>
        <li>Softwarebestandteile zu verändern,</li>
        <li>die Software weiterzuverkaufen,</li>
        <li>die Software zu vermieten,</li>
        <li>die Software Dritten zugänglich zu machen,</li>
        <li>KI-Funktionen nachzubilden oder auszulesen.</li>
      </ul>
      <p>Bei Verstößen ist EasyGutachter berechtigt, den Zugang sofort zu sperren.</p>

      <h2>§ 5 Urheberrecht und geistiges Eigentum</h2>
      <p>Sämtliche Rechte an der Software verbleiben ausschließlich bei EasyGutachter.</p>
      <p>Dies gilt insbesondere für:</p>
      <ul>
        <li>Softwarecode,</li>
        <li>Datenbanken,</li>
        <li>Layouts,</li>
        <li>Logos,</li>
        <li>Marken,</li>
        <li>KI-Systeme,</li>
        <li>Schnittstellen,</li>
        <li>Dokumentationen,</li>
        <li>Vorlagen.</li>
      </ul>
      <p>
        Jegliche Nutzung außerhalb der vertraglich eingeräumten Rechte bedarf der vorherigen
        schriftlichen Zustimmung.
      </p>
      <p>Verstöße verpflichten den Nutzer zum Ersatz sämtlicher entstandener Schäden.</p>

      <h2>§ 6 Vertragslaufzeit</h2>
      <p>Die Mindestvertragslaufzeit beträgt 12 Monate.</p>
      <p>
        Der Vertrag verlängert sich automatisch um jeweils einen weiteren Monat, sofern er nicht mit
        einer Frist von 30 Tagen gekündigt wird.
      </p>
      <p>Das Recht zur außerordentlichen Kündigung bleibt unberührt.</p>

      <h2>§ 7 Vergütung</h2>
      <p>
        Die Höhe der Vergütung ergibt sich aus der jeweils gültigen Preisliste oder dem individuellen
        Vertrag.
      </p>
      <p>Die Vergütung ist monatlich im Voraus fällig.</p>
      <p>
        Rechnungen sind innerhalb von sieben Kalendertagen nach Rechnungsstellung ohne Abzug zahlbar.
      </p>
      <p>Gerät der Nutzer in Verzug, werden Verzugszinsen in gesetzlicher Höhe berechnet.</p>
      <p>
        Zusätzlich trägt der Nutzer sämtliche Mahn-, Inkasso-, Gerichts- und Rechtsanwaltskosten.
      </p>

      <h2>§ 8 Zahlungsverzug</h2>
      <p>
        Befindet sich der Nutzer länger als 14 Kalendertage im Zahlungsverzug, ist EasyGutachter
        berechtigt:
      </p>
      <ul>
        <li>Funktionen einzuschränken,</li>
        <li>Datenexporte zu sperren,</li>
        <li>den Zugang teilweise oder vollständig zu deaktivieren.</li>
      </ul>
      <p>
        Befindet sich der Nutzer länger als 30 Kalendertage im Zahlungsverzug, ist EasyGutachter
        berechtigt:
      </p>
      <ul>
        <li>den Vertrag fristlos zu kündigen,</li>
        <li>sämtliche offenen Forderungen sofort fällig zu stellen,</li>
        <li>die Einziehungsbefugnis gemäß § 9 zu widerrufen.</li>
      </ul>

      <h2>§ 9 Sicherungsabtretung von Gutachtenhonoraren</h2>
      <h3>1. Abtretung</h3>
      <p>
        Zur Sicherung sämtlicher gegenwärtiger und zukünftiger Ansprüche von EasyGutachter aus der
        Geschäftsbeziehung tritt der Nutzer hiermit sämtliche bestehenden und zukünftigen Forderungen
        aus:
      </p>
      <ul>
        <li>Kfz-Gutachten,</li>
        <li>Schadengutachten,</li>
        <li>Wertgutachten,</li>
        <li>Fahrzeugbewertungen,</li>
        <li>Restwertermittlungen,</li>
        <li>Beweissicherungsgutachten,</li>
        <li>technischen Gutachten,</li>
        <li>Beratungsleistungen,</li>
      </ul>
      <p>an EasyGutachter ab. EasyGutachter nimmt die Abtretung an.</p>

      <h3>2. Sicherungszweck</h3>
      <p>
        Die Abtretung dient der Sicherung sämtlicher Forderungen von EasyGutachter, insbesondere:
      </p>
      <ul>
        <li>Lizenzgebühren,</li>
        <li>Softwaregebühren,</li>
        <li>Schulungsgebühren,</li>
        <li>Supportkosten,</li>
        <li>Mahnkosten,</li>
        <li>Inkassokosten,</li>
        <li>Rechtsanwaltskosten,</li>
        <li>Schadensersatzansprüche.</li>
      </ul>

      <h3>3. Widerruf der Einziehungsbefugnis</h3>
      <p>
        Solange der Nutzer seinen Zahlungsverpflichtungen ordnungsgemäß nachkommt, bleibt er
        berechtigt, die abgetretenen Forderungen selbst einzuziehen.
      </p>
      <p>Bei Zahlungsverzug von mehr als 14 Tagen kann EasyGutachter diese Berechtigung widerrufen.</p>

      <h3>4. Offenlegung</h3>
      <p>Nach Widerruf ist EasyGutachter berechtigt, die Abtretung gegenüber:</p>
      <ul>
        <li>Versicherungen,</li>
        <li>Geschädigten,</li>
        <li>Rechtsanwälten,</li>
        <li>Leasinggesellschaften,</li>
        <li>Autohäusern,</li>
        <li>Flottenbetreibern,</li>
        <li>sonstigen Schuldnern</li>
      </ul>
      <p>offenzulegen.</p>

      <h3>5. Direkte Einziehung</h3>
      <p>
        EasyGutachter ist berechtigt, sämtliche abgetretenen Forderungen im eigenen Namen einzuziehen
        und abzurechnen.
      </p>
      <p>Der Nutzer erteilt hierzu seine ausdrückliche und unwiderrufliche Zustimmung.</p>

      <h3>6. Auskunftspflicht</h3>
      <p>
        Der Nutzer verpflichtet sich, EasyGutachter auf Verlangen unverzüglich sämtliche Informationen
        zur Verfügung zu stellen, die zur Durchsetzung der abgetretenen Forderungen erforderlich sind.
      </p>
      <p>Hierzu gehören insbesondere:</p>
      <ul>
        <li>Auftragsunterlagen,</li>
        <li>Versicherungsdaten,</li>
        <li>Schadenakten,</li>
        <li>Rechnungen,</li>
        <li>Gutachten,</li>
        <li>Kundendaten.</li>
      </ul>

      <h3>7. Vertragsstrafe bei Vereitelung</h3>
      <p>
        Verhindert der Nutzer die Durchsetzung einer wirksam abgetretenen Forderung vorsätzlich oder
        grob fahrlässig, schuldet er eine Vertragsstrafe in Höhe von <strong>2.500 €</strong> je
        Verstoß.
      </p>
      <p>Die Geltendmachung weiterer Schäden bleibt vorbehalten.</p>

      <h2>§ 10 Datenschutz</h2>
      <p>Die Verarbeitung personenbezogener Daten erfolgt nach den Bestimmungen der DSGVO.</p>
      <p>Sofern erforderlich, schließen die Parteien einen Auftragsverarbeitungsvertrag.</p>
      <p>
        Der Nutzer bleibt Verantwortlicher im Sinne der DSGVO für die von ihm verarbeiteten
        Kundendaten.
      </p>

      <h2>§ 11 Verfügbarkeit</h2>
      <p>
        EasyGutachter bemüht sich um eine Verfügbarkeit von mindestens 99 % im Jahresdurchschnitt.
      </p>
      <p>Ausgenommen hiervon sind:</p>
      <ul>
        <li>Wartungsarbeiten,</li>
        <li>höhere Gewalt,</li>
        <li>Ausfälle von Rechenzentren,</li>
        <li>Ausfälle von Internetdiensten.</li>
      </ul>

      <h2>§ 12 Haftung</h2>
      <p>EasyGutachter haftet unbeschränkt für Vorsatz und grobe Fahrlässigkeit.</p>
      <p>
        Bei einfacher Fahrlässigkeit haftet EasyGutachter ausschließlich bei Verletzung wesentlicher
        Vertragspflichten.
      </p>
      <p>Die Haftung ist auf den vertragstypischen, vorhersehbaren Schaden begrenzt.</p>
      <p>Eine Haftung für entgangenen Gewinn wird ausgeschlossen.</p>
      <p>EasyGutachter haftet nicht für fehlerhafte Gutachteninhalte des Nutzers.</p>

      <h2>§ 13 Verbotene Nutzung</h2>
      <p>Es ist untersagt:</p>
      <ul>
        <li>fingierte Gutachten zu erstellen,</li>
        <li>Versicherungsbetrug zu begehen,</li>
        <li>Daten zu manipulieren,</li>
        <li>Zugangsdaten weiterzugeben,</li>
        <li>Sicherheitsmechanismen zu umgehen,</li>
        <li>die Software zur Begehung rechtswidriger Handlungen zu nutzen.</li>
      </ul>
      <p>Bei Verstößen kann EasyGutachter den Vertrag fristlos kündigen.</p>

      <h2>§ 14 Referenznutzung</h2>
      <p>
        EasyGutachter ist berechtigt, den Firmennamen, das Logo sowie öffentlich zugängliche
        Unternehmensdaten des Nutzers als Referenz auf Webseiten, Werbematerialien und Präsentationen
        zu verwenden.
      </p>
      <p>Der Nutzer kann dieser Nutzung jederzeit schriftlich widersprechen.</p>

      <h2>§ 15 Gerichtsstand und anwendbares Recht</h2>
      <p>
        Ausschließlicher Gerichtsstand für sämtliche Streitigkeiten aus oder im Zusammenhang mit
        diesem Vertrag ist <strong>Köln</strong>, soweit gesetzlich zulässig.
      </p>
      <p>
        Es gilt ausschließlich das Recht der Bundesrepublik Deutschland unter Ausschluss des
        UN-Kaufrechts.
      </p>

      <h2>§ 16 Salvatorische Klausel</h2>
      <p>
        Sollte eine Bestimmung dieser AGB ganz oder teilweise unwirksam sein oder werden, bleibt die
        Wirksamkeit der übrigen Bestimmungen unberührt.
      </p>
      <p>
        Die Parteien verpflichten sich, die unwirksame Regelung durch eine Regelung zu ersetzen, die
        dem wirtschaftlichen Zweck der unwirksamen Regelung am nächsten kommt.
      </p>

      <p className="text-sm text-zinc-500 mt-10">
        Bei Rückfragen erreichen Sie uns unter{" "}
        <a href="mailto:info@easy-gutachter.de">info@easy-gutachter.de</a>.
      </p>
    </PublicLegalPage>
  );
}
